const ro = {
    actionAlready: "Nu ești încă înregistrat? Autentifică-te",
    actionExit: "Ieșire",
    actionLogin: "AUTENTIFICARE",
    actionRegister: "ÎNREGISTRARE",
    actionSave: "SALVEAZĂ",
    actionStart: "ÎNCEPE",
    actionContinue: "CONTINUĂ",
    actionReset: "RESETARE EVALUARE",
    actionDoDiagnost: "ARATĂ DIAGNOSTICUL",
    actionYes: "Da",
    actionNo: "Nu",
    actionNext: "URMĂTORUL",
    actionBusinessCase: "ARATĂ BUNELE PRACTICI ALE COMPANIEI",
    actionBusinessCases: "ARATĂ BUNELE PRACTICI ALE COMPANIILOR",
    actionOpenUrl: "DESCHIDE URL",
    actionFilter: "FILTRARE",

    /** HOME */
    msgHomeTitleOne: "Măsurați și creșteți nivelul de maturitate circulară al companiei dumneavoastră de mobilier",
    msgHomeSubTitle: "Instrumentul online FurnCIRCLE evaluează progresul companiei dumneavoastră către maturitatea circulară pe baza strategiilor de design circular implementate",

    msgHomeSection2: "Cerințele de circularitate se extind.</br>Sunteți pregătit?",
    msgHomeSection2Text: "<ul style='padding-left: 20px'><li>Răspundeți la întrebările despre strategiile de design circular implementate în prezent în compania dumneavoastră.</li><li>Obțineți indicele de maturitate circulară al companiei dumneavoastră.</li><li>Identificați strategii de design și bune practici ale companiilor pentru a duce compania dumneavoastră la nivelul următor.</li><li>Învățați din bunele practici ale companiilor reale pentru a continua să îmbunătățiți nivelul de maturitate circulară al companiei dumneavoastră.</li></ul>",
    msgHomeSection3: "Parteneri",
    msgHomeSection2Btn: "Începeți evaluarea",
    msgHomeSection3Btn: "CONTACT",

    /** HEADER */
    msgHeader1: "Strategii de design circular și bune practici",
    msgHeader4: "Autentificare",

    /** DRAWER */
    msgCompany: "COMPANIE",
    msgDrawer1: "1. Răspundeți",
    msgDrawer2: "2. Evaluați",
    msgDrawer3: "3. Îmbunătățiți",
    msgDrawer4: "Colecția de strategii",
    msgDrawer6: "Setări",
    msgDrawer7: "Ieșire",

    /** LOGIN */
    msgWelcome: "Bine ați venit",
    msgWelcomeSubtitle: "Vă rugăm să vă autentificați pentru a continua",

    /** REGISTER */
    msgGetStarted: "Începeți",
    msgGetStartedSubtitle: "Acest instrument de autoevaluare este gratuit și confidențial",

    msgFirstname: "Prenume",
    msgLastname: "Nume de familie",
    msgEmail: "Email",
    msgPassword: "Parolă",
    msgConfirmPassword: "Confirmați parola",
    msgCompanyUser: "Companie sau nume de utilizator",

    msgNotRegister: "Nu sunteți încă înregistrat? <b>Creați un cont aici</b>",
    msgAlreadyRegister: "Sunteți deja înregistrat? <b>Autentificați-vă aici</b>",

    /** HOME TOOL */
    msgClickImage: "Faceți clic pentru a extinde sistemul modelului liniar versus circular.",

    msgArea: "ZONĂ",
    msgProgress: "ÎNTREBĂRI RĂSPUNSE",

    msgAssessmentAreas: "Strategii de design circular și ciclul de viață al produsului",
    msgAssessmentDesc: "Strategiile de design circular sunt aplicate în faza de proiectare și dezvoltare a produselor, deși impactul lor (pozitiv) poate apărea în una sau mai multe faze ulterioare ale ciclului de viață al produsului. Prin urmare, un mod de a clasifica strategiile de design circular este în funcție de etapa ciclului de viață afectată: proiectare, resurse materiale, producție, distribuție, utilizare și sfârșitul vieții.<br/><br/><span style=\"font-weight:bold; font-size:16px;\">Vă rugăm, răspundeți la toate întrebările pentru fiecare bloc sau fază a ciclului de viață, determinați nivelul dumneavoastră de maturitate circulară și planificați îmbunătățirea și tranziția către o economie mai circulară!</span>",

    msgAssessment: "Evaluare FurnCIRCLE",
    msgNotApply: "Bifează toate răspunsurile care se aplică performanței circulare actuale a companiei tale. Răspunsurile sunt salvate automat.",
    msgMarkImportant: "Marcați ca important",
    msgComment: "Comentariu",
    msgCommentHolder: "Puteți scrie aici orice informație legată sau comentarii proprii.",

    /** ANSWER */
    msgPerformance: "Raport de evaluare",
    msgPerformanceSubtitle: "Verificați indicele de maturitate circulară al companiei dumneavoastră și fiecare fază a ciclului de viață al produselor dumneavoastră.",
    msgCompanyLevel: "Indicele de maturitate circulară al companiei dumneavoastră (0%-100%)",
    msgBlockArea: "FAZĂ A CICLULUI DE VIAȚĂ",
    msgBlockValues: "VALORI",

    /** ASSESS */
    msgImprovement: "Raport de îmbunătățire",
    msgImprovementMainSubtitle: "Învățați ce puteți face pentru a îmbunătăți continuu circularitatea companiei dumneavoastră. Cunoașteți strategiile de design și bunele practici ale companiilor pentru a duce compania dumneavoastră la următorul nivel.</br></br>Fazele ciclului de viață și strategiile de design circular cu etichetă/rotundă „roșie” au un nivel de performanță egal sau mai mic de 25% din valoarea lor maximă și pot fi considerate o prioritate de top pentru îmbunătățirea circularității companiei. Fazele sau strategiile cu etichetă/rotundă „portocalie” au un nivel de performanță mai mare de 25% și mai mic sau egal cu 75%, deci este important să abordați și îmbunătățirea acestora. Fazele sau strategiile cu etichetă/rotundă „verde” au un nivel de performanță mai mare de 75% și, prin urmare, sunt mai puțin o prioritate pentru îmbunătățire.",
    msgImprovementSubtitle: "Învățați ce puteți face pentru a îmbunătăți continuu circularitatea companiei dumneavoastră. Cunoașteți strategiile de design și bunele practici ale companiilor pentru a duce compania dumneavoastră la următorul nivel.",
    msgLifecyclePhases: "Fazele ciclului de viață",
    msgLifecycleIndex: "Indicele de circularitate al fazei",
    msgActionsToImplement: "Acțiuni de implementat:",
    msgBaselineScore: "Scorul meu de referință",
    msgBusinessCaseEmpty: "Felicitări! Ați implementat deja principalele strategii incluse în această categorie",

    msgCat1: "ECONOMIC ȘI ORGANIZAȚIONAL",
    msgCat2: "SOCIAL",
    msgCat3: "ENVIRONMENTAL",

    /** STRATEGIES COLLECTION */
    msgStrategiesSubtitle: "Răsfoiți și explorați întreaga colecție de strategii de design circular și bune practici ale companiilor din proiectul FurnCIRCLE.",
    msgLifecyclePhase: "Faza ciclului de viață",
    msgDifficulty: "Dificultatea implementării",
    msgBusinessDynamics: "Generare sau livrare de valoare",
    msgBusinessFactors: "Propunere de valoare / Costuri / Beneficii",

    /** SETTINGS */
    msgUserInfo: "Informații utilizator",
    msgUserCredentials: "Date de autentificare utilizator",

    /** MODAL */
    msgAreSure: "Sunteți sigur?",

    msgSuccess: "Actualizare date cu succes",
    msgDeleteSuccess: "Ștergere date cu succes",

    /** ALT TEXT */
    msgSaveCommentAlt: "Salvează “Comentariul”. Nu este necesar să salvezi răspunsurile la întrebări; acestea sunt salvate automat.",
    msgDifficultyAlt: "Această etichetă indică dificultatea implementării strategiei de design circular.",
    msgBusinessBlockAlt: "Această etichetă indică care bloc de afaceri din modelul CANVAS (Generarea Valorii sau Livrarea Valorii) este afectat de implementarea strategiei de design circular.",
    msgImpactBlockAlt: "Această etichetă indică care bloc de impact din modelul CANVAS (Costuri, Beneficii sau Propunerea de Valoare) este afectat de implementarea strategiei de design circular.",

    /** ERROR */
    errorOblData: "Completați toate câmpurile obligatorii",
    errorEmailFormat: "Eroare în formatul emailului",
    errorUserIncorrect: "Email/parolă incorectă",
    errorSend: "Eroare de comunicare, vă rugăm să așteptați și să încercați din nou mai târziu",
    errorLength: "Numărul de caractere a fost depășit",
    errorPassSame: "Parolele nu sunt identice",

    /** RECOVERY PASS */
    msgRecoveryPassword: "Recuperare parolă",
    msgRecoveryPasswordSubtitle: "Vă rugăm să introduceți adresa de email pentru a primi un cod de resetare a parolei.",
    msgCode: "Cod",
    msgNewPassword: "Parolă nouă",
    actionRequestCode: "SOLICITĂ COD",
    actionUpdate: "ACTUALIZEAZĂ",
    actionBack: "ÎNAPOI",
    msgForgetPassword: "Ai uitat parola?",
    errorRecovery: "Eroare la recuperarea parolei, vă rugăm să verificați codul furnizat",

    /** FOOTER */
    msgFooterContact: "CONTACT",

    msgFooterGr: "Finanțat de Uniunea Europeană. Opiniile exprimate sunt însă ale autorului (autorilor) și nu reflectă neapărat punctele de vedere ale Uniunii Europene. Nici Uniunea Europeană, nici autoritatea de acordare nu pot fi făcute responsabile pentru acestea. Referință apel și acord de grant: SOCPL-2022-SOC-DIALOG-01 (Proiect 101102389)",
    msgCopyright: "Copyright&copy;2025 AMBIT. Toate drepturile rezervate",

    msgFooterLegal: "Notificare legală",
    msgFooterPrivacy: "Confidențialitate",
    msgFooterCookies: "Politica de cookies",

    /** PROGRESS VALUES */
    msgProgress0: "Strategii de design circular",

    /** COMPANY SIZES */
    msgCompanySize: "Dimensiunea companiei",
    msgCompanySize1: "Mai puțin de 10 angajați",
    msgCompanySize2: "10-30 angajați",
    msgCompanySize3: "30-50 angajați",
    msgCompanySize4: "Mai mult de 50 angajați",

    /** PRODUCT TYPES */
    msgProductType: "Tipul de produse pe care le fabricați",
    msgProductType1: "Tapiterie",
    msgProductType2: "Saltele",
    msgProductType3: "Baze de tapiterie, canapele, baze de pat",
    msgProductType4: "Subcontractor (rame, prelucrare, vopsire etc.)",
    msgProductType5: "Servicii (logistică specializată etc.)",
    msgProductType6: "Mobilier din placaj (melaminat, furnir, lacuit etc.)",
    msgProductType7: "Mobilier din lemn",
    msgProductType8: "Scaune",
    msgProductType9: "Mobilier de birou",
    msgProductType10: "Mobilier pentru spații publice și utilizări",
    msgProductType11: "Uși, feronerie și produse de tâmplărie",
    msgProductType12: "Facilități personalizate (magazine, biblioteci, restaurante, afaceri profesionale etc.)",
    msgProductType13: "Iluminat",
    msgProductType14: "Acoperiri și pardoseli",
    msgProductType15: "Textile",
    msgProductType16: "Decorațiuni",

    /* COUNTRIES */
    msgCountry: "Țară",
    msgAfghanistan: "Afganistan",
    msgAlbania: "Albania",
    msgAlgeria: "Algeria",
    msgAmericanSamoa: "Samoa Americană",
    msgAndorra: "Andorra",
    msgAngola: "Angola",
    msgAnguilla: "Anguilla",
    msgAntarctica: "Antarctica",
    msgAntiguaandBarbuda: "Antigua și Barbuda",
    msgArgentina: "Argentina",
    msgArmenia: "Armenia",
    msgAruba: "Aruba",
    msgAustralia: "Australia",
    msgAustria: "Austria",
    msgAzerbaijan: "Azerbaidjan",
    msgBahamas: "Bahamas",
    msgBahrain: "Bahrain",
    msgBangladesh: "Bangladesh",
    msgBarbados: "Barbados",
    msgBelarus: "Belarus",
    msgBelgium: "Belgia",
    msgBelize: "Belize",
    msgBenin: "Benin",
    msgBermuda: "Bermuda",
    msgBhutan: "Bhutan",
    msgBolivia: "Bolivia",
    msgBosniaHerzegovina: "Bosnia și Herțegovina",
    msgBotswana: "Botswana",
    msgBouvetIsland: "Insula Bouvet",
    msgBrazil: "Brazilia",
    msgBritishIndian: "Teritoriul Oceanului Indian Britanic",
    msgBrunei: "Brunei",
    msgBulgaria: "Bulgaria",
    msgBurkinaFaso: "Burkina Faso",
    msgBurundi: "Burundi",
    msgCambodia: "Cambodgia",
    msgCameroon: "Camerun",
    msgCanada: "Canada",
    msgCapeVerde: "Capul Verde",
    msgCaymanIslands: "Insulele Cayman",
    msgCentralAfrican: "Republica Centrafricană",
    msgChad: "Ciad",
    msgChile: "Chile",
    msgChina: "China",
    msgChristmasIsland: "Insula Crăciunului",
    msgCocosIslands: "Insulele Cocos (Keeling)",
    msgColombia: "Columbia",
    msgComoros: "Comore",
    msgCongo: "Congo",
    msgRepublicCongo: "Republica Democrată Congo",
    msgCookIslands: "Insulele Cook",
    msgCostaRica: "Costa Rica",
    msgIvoryCoast: "Coasta de Fildeș",
    msgCroatia: "Croația",
    msgCuba: "Cuba",
    msgCyprus: "Cipru",
    msgCzechRepublic: "Republica Cehă",
    msgDenmark: "Danemarca",
    msgDjibouti: "Djibouti",
    msgDominica: "Dominica",
    msgDominicanRepublic: "Republica Dominicană",
    msgEastTimor: "Timorul de Est",
    msgEcuador: "Ecuador",
    msgEgypt: "Egipt",
    msgEngland: "Anglia",
    msgElSalvador: "El Salvador",
    msgEquatorialGuinea: "Guineea Echatorială",
    msgEritrea: "Eritreea",
    msgEstonia: "Estonia",
    msgEthiopia: "Etiopia",
    msgFalklandIslands: "Insulele Falkland",
    msgFaroeIslands: "Insulele Feroe",
    msgFijiIslands: "Insulele Fiji",
    msgFinland: "Finlanda",
    msgFrance: "Franța",
    msgFrenchGuiana: "Guyana Franceză",
    msgFrenchPolynesia: "Polinezia Franceză",
    msgFrenchSouthern: "Teritoriile Franceze de Sud",
    msgGabon: "Gabon",
    msgGambia: "Gambia",
    msgGeorgia: "Georgia",
    msgGermany: "Germania",
    msgGhana: "Ghana",
    msgGibraltar: "Gibraltar",
    msgGreece: "Grecia",
    msgGreenland: "Groenlanda",
    msgGrenada: "Grenada",
    msgGuadeloupe: "Guadelupa",
    msgGuam: "Guam",
    msgGuatemala: "Guatemala",
    msgGuernsey: "Guernsey",
    msgGuinea: "Guineea",
    msgGuineaBissau: "Guineea-Bissau",
    msgGuyana: "Guyana",
    msgHaiti: "Haiti",
    msgHeardMcDonald: "Insula Heard și Insulele McDonald",
    msgHolySee: "Sfântul Scaun (Statul Vatican)",
    msgHonduras: "Honduras",
    msgHongKong: "Hong Kong",
    msgHungary: "Ungaria",
    msgIceland: "Islanda",
    msgIndia: "India",
    msgIndonesia: "Indonezia",
    msgIran: "Iran",
    msgIraq: "Irak",
    msgIreland: "Irlanda",
    msgIsrael: "Israel",
    msgIsleMan: "Insula Man",
    msgItaly: "Italia",
    msgJamaica: "Jamaica",
    msgJapan: "Japonia",
    msgJersey: "Jersey",
    msgJordan: "Iordania",
    msgKazakhstan: "Kazahstan",
    msgKenya: "Kenya",
    msgKiribati: "Kiribati",
    msgKuwait: "Kuweit",
    msgKyrgyzstan: "Kârgâzstan",
    msgLaos: "Laos",
    msgLatvia: "Letonia",
    msgLebanon: "Liban",
    msgLesotho: "Lesotho",
    msgLiberia: "Liberia",
    msgLibyanJamahiriya: "Jamahiriya Arabă Libiană",
    msgLiechtenstein: "Liechtenstein",
    msgLithuania: "Lituania",
    msgLuxembourg: "Luxemburg",
    msgMacao: "Macao",
    msgNorthMacedonia: "Macedonia de Nord",
    msgMadagascar: "Madagascar",
    msgMalawi: "Malawi",
    msgMalaysia: "Malaysia",
    msgMaldives: "Maldivele",
    msgMali: "Mali",
    msgMalta: "Malta",
    msgMarshallIslands: "Insulele Marshall",
    msgMartinique: "Martinica",
    msgMauritania: "Mauritania",
    msgMauritius: "Mauritius",
    msgMayotte: "Mayotte",
    msgMexico: "Mexic",
    msgMicronesia: "Micronezia, Statele Federate din",
    msgMoldova: "Moldova",
    msgMonaco: "Monaco",
    msgMongolia: "Mongolia",
    msgMontserrat: "Montserrat",
    msgMontenegro: "Muntenegru",
    msgMorocco: "Maroc",
    msgMozambique: "Mozambic",
    msgMyanmar: "Myanmar",
    msgNamibia: "Namibia",
    msgNauru: "Nauru",
    msgNepal: "Nepal",
    msgNetherlands: "Olanda",
    msgNetherlandsAntilles: "Antilele Olandeze",
    msgNewCaledonia: "Noua Caledonie",
    msgNewZealand: "Noua Zeelandă",
    msgNicaragua: "Nicaragua",
    msgNiger: "Niger",
    msgNigeria: "Nigeria",
    msgNiue: "Niue",
    msgNorfolkIsland: "Insula Norfolk",
    msgNorthKorea: "Coreea de Nord",
    msgNorthernIreland: "Irlanda de Nord",
    msgNorthernMariana: "Insulele Mariane de Nord",
    msgNorway: "Norvegia",
    msgOman: "Oman",
    msgPakistan: "Pakistan",
    msgPalau: "Palau",
    msgPalestine: "Palestina",
    msgPanama: "Panama",
    msgPapua: "Papua Noua Guinee",
    msgParaguay: "Paraguay",
    msgPeru: "Peru",
    msgPhilippines: "Filipine",
    msgPitcairn: "Pitcairn",
    msgPoland: "Polonia",
    msgPortugal: "Portugalia",
    msgPuertoRico: "Puerto Rico",
    msgQatar: "Qatar",
    msgReunion: "Reuniune",
    msgRomania: "România",
    msgRussianFederation: "Federația Rusă",
    msgRwanda: "Rwanda",
    msgSaintHelena: "Sfânta Elena",
    msgSaintKitts: "Saint Kitts și Nevis",
    msgSaintLucia: "Sfânta Lucia",
    msgSaintPierre: "Saint Pierre și Miquelon",
    msgSaintVincent: "Saint Vincent și Grenadinele",
    msgSamoa: "Samoa",
    msgSanMarino: "San Marino",
    msgSaoTome: "Sao Tome și Principe",
    msgSaudiArabia: "Arabia Saudită",
    msgScotland: "Scoția",
    msgSenegal: "Senegal",
    msgSerbia: "Serbia",
    msgSeychelles: "Seychelles",
    msgSierraLeone: "Sierra Leone",
    msgSingapore: "Singapore",
    msgSlovakia: "Slovacia",
    msgSlovenia: "Slovenia",
    msgSolomonIslands: "Insulele Solomon",
    msgSomalia: "Somalia",
    msgSouthAfrica: "Africa de Sud",
    msgSouthSandwich: "Georgia de Sud și Insulele Sandwich de Sud",
    msgSouthKorea: "Coreea de Sud",
    msgSouthSudan: "Sudanul de Sud",
    msgSpain: "Spania",
    msgSriLanka: "Sri Lanka",
    msgSudan: "Sudan",
    msgSuriname: "Surinam",
    msgSvalbardJan: "Svalbard și Jan Mayen",
    msgSwaziland: "Swaziland",
    msgSweden: "Suedia",
    msgSwitzerland: "Elveția",
    msgSyria: "Siria",
    msgTajikistan: "Tadjikistan",
    msgTanzania: "Tanzania",
    msgThailand: "Thailanda",
    msgTimorLeste: "Timorul de Est",
    msgTogo: "Togo",
    msgTokelau: "Tokelau",
    msgTonga: "Tonga",
    msgTrinidadTobago: "Trinidad și Tobago",
    msgTunisia: "Tunisia",
    msgTurkey: "Turcia",
    msgTurkmenistan: "Turkmenistan",
    msgTurksCaicos: "Insulele Turks și Caicos",
    msgTuvalu: "Tuvalu",
    msgUganda: "Uganda",
    msgUkraine: "Ucraina",
    msgUnitedArabEmirates: "Emiratele Arabe Unite",
    msgUnitedKingdom: "Regatul Unit",
    msgUnitedStates: "Statele Unite",
    msgUnitedStatesMinor: "Insulele din Oceanul Pacific ale Statelor Unite",
    msgUruguay: "Uruguay",
    msgUzbekistan: "Uzbekistan",
    msgVanuatu: "Vanuatu",
    msgVenezuela: "Venezuela",
    msgVietnam: "Vietnam",
    msgVirginIslandsBritish: "Insulele Virgine Britanice",
    msgVirginIslandsUS: "Insulele Virgine ale SUA",
    msgWales: "Țara Galilor",
    msgWallisFutuna: "Wallis și Futuna",
    msgWesternSahara: "Sahara de Vest",
    msgYemen: "Yemen",
    msgZambia: "Zambia",
    msgZimbabwe: "Zimbabwe",

}

export default ro;